import { render } from "./BallScaleRipple.vue?vue&type=template&id=352476de"
import script from "./BallScaleRipple.vue?vue&type=script&lang=js"
export * from "./BallScaleRipple.vue?vue&type=script&lang=js"

import exportComponent from "/home/circleci/project/frontend/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__